if($('.location-highlights').length) {

    // slowly scroll the div until the end, then fade it out temporarily, scroll back to the top quickly, and then fade it back in, and loop
    function scrollDiv() {
        $('.locations-scroller').animate({ scrollTop: $('.locations-scroller').prop("scrollHeight") }, 100000, 'linear', function() {
            console.log('done');
            // $(this).fadeOut('slow', function() {
                // $(this).scrollTop(0).fadeIn('slow', scrollDiv());
            // });
        });
    }

    scrollDiv();

}
